module.exports = __webpack_public_path__ + "img/tick_green.6429aaa3.svg";